import { render } from "./summaryTabOrderVehicle.vue?vue&type=template&id=c4f3fdec&ts=true"
import script from "./summaryTabOrderVehicle.vue?vue&type=script&lang=ts"
export * from "./summaryTabOrderVehicle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__